// removed by extract-text-webpack-plugin
module.exports = {"container":"_1WXdp","image":"_3Uhx7","button":"OOv7n","overlay":"_1kVk_"};


//////////////////
// WEBPACK FOOTER
// ./app/components/comment-form-image/comment-form-image.scss
// module id = 1729
// module chunks = 0